import { render, staticRenderFns } from "./arcocDigital.vue?vue&type=template&id=323157db&scoped=true&"
import script from "./arcocDigital.vue?vue&type=script&lang=js&"
export * from "./arcocDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323157db",
  null
  
)

export default component.exports